export class MotivoDesoneracao {
    Id: number = 0
    Descricao: string = ''
    CodigoNfe: number = 0
}
